/**
 * 游戏管理类
 */

import superManager from "./superManager";
import gameMode_json, {GAME_MODE, SCENE_MODE} from "./gameContent/gameMode_json";
import O1HD, {managers, modules, services} from "../gameEngine";
import data_control from "../libs/data_control";
import gameConfig from "../configs/gameConfig";
import versionNotice from "../../O1ModuleRes/frame/versionNotice";
import CSubLoginGame from "../../WsSdk/webSocketProtocol/wsInstanceList/CSubLoginGame";
import { releaseData } from "../User";


export interface GameModeDetail {
    type: GAME_MODE;
    name: string;
    sceneName: string;
    sceneMode: SCENE_MODE;
    explain: string;
    //看视频解锁次数
    lookVideCount: number;
    //是否为主场景 主场景会替换hall场景为loading后载入 必须为场景 不能为预制体
    isMainScene?: boolean;
    //已看视频次数
    currLookedVideoCount?: number;
    //看视频日期
    lookVideoUnlockDate?: string;
    //
    bundle?: cc.AssetManager.Bundle;
    //
    currScenePrefabNode?: cc.Node;
    //联机游戏
    onlineGameId?: number;
}

export default class GameManager extends superManager {
    //
    className: string = '游戏管理';
    //
    private m_currGameMode: GameModeDetail = null;
    //游戏公告
    private m_versionNotice: string = null;
    //游戏公告KEY
    private readonly m_VERSION_NOTICE_KEY: string = 'game-version-notice';

    platName:string = null;

    constructor() {
        super();
    }

    async loadManager(): Promise<boolean> {
        await super.loadManager();
        //
        this.m_versionNotice = O1HD.getServices().localStorageSrv.getStorage(this.m_VERSION_NOTICE_KEY);
        return Promise.resolve(true);
    }

    //游戏首次进入
    onGameRun() {

        //
        let currVersion = gameConfig.VERSION_NOTICE;
        //
        if (this.m_versionNotice != currVersion) {
            //
            this.m_versionNotice = currVersion;
            O1HD.getServices().localStorageSrv.setStorage(this.m_VERSION_NOTICE_KEY, this.m_versionNotice);
            //
            this.showVersionNotice();
        }
        const tt = window['tt'];
        if (tt) {
            let options = tt.getLaunchOptionsSync();
            console.log(options.showFrom);
            console.log('启动参数', options, JSON.stringify(options));
            let data:releaseData = {
                oaid: options.query.oaid,
                promotionid: options.query.promotionid,
                callback: options.query.callback,
                ad_type: options.query.ad_type,
                adid: options.query.adid,
                aid: options.query.aid,
                clickid: options.query.clickid,
                creativeid: options.query.creativeid,
                creativetype: options.query.creativetype,
                mpversion: options.query.mpversion
            };
            O1HD.getModules().gameHttpModule.user.setReleaseData(data);
            tt.getSystemInfo({
                complete: ((res) => {
                    if (res) {
                        this.platName = res.appName;
                        console.log("app名称", this.platName);
                    }
                })
            })
        }
    }

    showVersionNotice() {
        if (this.m_versionNotice) {
            modules().uiControlModule.showFramePrefab('preload/frame/versionNotice', null, false, node => {
                node.getComponent(versionNotice).setNotice(this.m_versionNotice);
            });
        }
        // this.m_versionNotice && O1HD.getModules().uiControlModule.showDialogBox('版本公告', this.m_versionNotice);
    }

    getVersionNotice() {
        return this.m_versionNotice;
    }

    loadModeOver() {
        console.log('加载子游戏场景', this.m_currGameMode.sceneName);
        O1HD.getModules().uiControlModule.showLoading().then();
        //
        switch (this.m_currGameMode.sceneMode) {
            case SCENE_MODE.FIRE: {
                O1HD.loadScene(this.m_currGameMode.sceneName, () => {
                    O1HD.getModules().uiControlModule.hideLoading();
                    if (this.m_currGameMode.onlineGameId) {
                        modules().uiControlModule.showFramePrefab('preload/frame/ping', O1HD.Canvas(), false);
                    }
                    services().miniGameSrv.getAppApiInstance().screenFit();
                });
                break;
            }
            case SCENE_MODE.PREFAB: {
                this.m_currGameMode.bundle.load(this.m_currGameMode.sceneName, cc.Prefab, (error, assets: cc.Prefab) => {
                    if (error) {
                        console.error('#55 模式对应预制体不存在或异常', this.m_currGameMode);
                        return;
                    }
                    this.m_currGameMode.currScenePrefabNode = cc.instantiate(assets);
                    O1HD.Canvas().addChild(this.m_currGameMode.currScenePrefabNode);
                    O1HD.getModules().uiControlModule.hideLoading();
                });
                break;
            }
            default: {
                O1HD.getModules().uiControlModule.hideLoading();
                console.error('#56 请指示加载模式的类型');
                break;
            }
        }
    }

    //获取主场景名
    getMainSceneNameAndLoadBundle(): string | GameModeDetail {
        //
        //
        for (let mode of gameMode_json()) {
            if (mode.isMainScene) {
                //是场景
                if (mode.sceneMode == SCENE_MODE.FIRE) {
                    this.m_currGameMode = mode;
                    //加载子包
                    return mode;
                } else {
                    console.error('入口场景模式不允许为预制体', mode.name, mode);
                    return null;
                }
            }
        }
        return 'hall';
    }

    setMainModeLoaded(mode: GameModeDetail) {
        this.m_currGameMode = mode;
    }

    protected loginGameServer(gameId: number) {
        modules().uiControlModule.showLoading(null, '正在登录游戏……').then(() => {
            const cMsg = new CSubLoginGame(gameId);
            managers().socketMgr.sendHallMessage(cMsg);
        });
    }

    onLoginFailGameServer(failMsg: string) {
        modules().uiControlModule.showMessageBox(failMsg);
        modules().uiControlModule.hideLoading();
    }

    onLoginSuccessGameServer(gameId: number) {
        modules().uiControlModule.showMessageBox('登录成功');
        //
        gameMode_json().forEach(mode => {
            if (mode.onlineGameId == gameId) {
                this.onLoadCurrModeDetail(mode).then();
                return;
            }
        });
    }

    //选择模式
    async selectMode(mode: GAME_MODE) {
        //
        let currMode: GameModeDetail = null;
        //
        currMode = gameMode_json()[mode];
        if (currMode == null) {
            O1HD.getModules().uiControlModule.showMessageBox('敬请期待');
            return;
        }
        //在线游戏
        if (currMode.onlineGameId) {
            this.loginGameServer(currMode.onlineGameId);
        } else {//单机游戏
            await this.onLoadCurrModeDetail(currMode);
        }
    }

    protected async onLoadCurrModeDetail(currMode: GameModeDetail) {//单机游戏
        this.m_currGameMode = currMode;
        //
        //在其他地方已经加载子包
        if (currMode.bundle == null) {
            console.debug('子包是否已加载', currMode.name, cc.assetManager.bundles.get(currMode.name) != null);
            let bundle = cc.assetManager.bundles.get(currMode.name);
            if (bundle) {
                currMode.bundle = bundle;
            }
        }
        if (currMode.bundle == null) {
            console.log('显示进度');
            O1HD.getModules().uiControlModule.showLoading().then();
            console.log('进度显示完', currMode);
            cc.assetManager.loadBundle(currMode.name, (err, bundle: cc.AssetManager.Bundle) => {
                O1HD.getModules().uiControlModule.hideLoading();
                if (err) {
                    console.error('游戏子包不存在', currMode);
                    return;
                }
                currMode.bundle = bundle;
                this.loadModeOver();
            })
        } else {
            //
            this.loadModeOver();
        }
    }


    getCurrMode() {
        return this.m_currGameMode;
    }

    getCurrModeNeedPower() {
        let {type} = this.m_currGameMode;
        return this.getModeNeedPower(type);
    }

    getModeNeedPower(mode: GAME_MODE) {
        //TODO:获取对应体力 对照oss根据type映射
        return 0;
    }

    getModeInfo(mode: GAME_MODE) {
        let md = gameMode_json()[mode];
        if (md && md.lookVideCount > 0) {
            md.currLookedVideoCount =
                Number(O1HD.getServices().localStorageSrv.getStorage(`mode-looked-${md.type}`) || '');
            md.lookVideoUnlockDate =
                O1HD.getServices().localStorageSrv.getStorage(`mode-looked-date-${md.type}`) || '';
            //
        }
        return md;
    }

    addModeLookCount(mode: GAME_MODE) {
        let md = gameMode_json()[mode];
        if (md.lookVideCount > 0) {
            md.currLookedVideoCount++;
            O1HD.getServices().localStorageSrv.setStorage(`mode-looked-${md.type}`, md.currLookedVideoCount);
            O1HD.getServices().localStorageSrv.setStorage(`mode-looked-date-${md.type}`, data_control.getCurrDateDayString());
        }
    }

    //返回大厅
    async returnMainScene() {
        await O1HD.getModules().uiControlModule.showLoading();
        //
        switch (this.m_currGameMode.sceneMode) {
            case SCENE_MODE.PREFAB: {
                if (this.m_currGameMode.currScenePrefabNode && this.m_currGameMode.currScenePrefabNode.isValid) {
                    this.m_currGameMode.currScenePrefabNode.destroy();
                }
                this.m_currGameMode.currScenePrefabNode = null;
                //
                O1HD.getModules().uiControlModule.hideLoading();
                break;
            }
            case SCENE_MODE.FIRE: {
                //
                O1HD.getModules().uiControlModule.hideLoading();
                O1HD.loadScene('hall');
                break;
            }
        }
    }

    chaoPiaoPrefab:cc.Prefab = null;

    chaoPiaoInitPos:cc.Vec2 = null;

    loadChaoPiaoPos(pos:cc.Vec2){
        if(this.chaoPiaoInitPos == null){
            this.chaoPiaoInitPos = pos.clone();
        }
    }

    loadChaoPiaoPrefab(){
        O1HD.getModules().uiControlModule.getGameBundle().load("prefab/moneyPrefab",cc.Prefab,(err,prefab:cc.Prefab)=>{
            if(err){
                console.error("加载钞票预制体失败",err);
                return;
            }
            this.chaoPiaoPrefab = prefab;
        });
    }

    /**
     *
     */
    addGoodsEffect( addCount : number , worldPos : cc.Vec2 ,uiNode ?: cc.Node ){
        let lakeAddCoins = addCount;
        O1HD.getModules().uiControlModule.getGameBundle().load("prefab/lbAddEffect",cc.Prefab,(err,prefab:cc.Prefab)=>{
            if(err){
                console.error("加载添加预制体失败",err);
                return;
            }
            let addCoinEffectNode = cc.instantiate( prefab );
            let parentNode = uiNode ? uiNode : O1HD.Canvas();
            parentNode.addChild( addCoinEffectNode );
            addCoinEffectNode.setPosition( parentNode.convertToNodeSpaceAR( worldPos ));
            addCoinEffectNode.y += 30;
            addCoinEffectNode.active = true;
            addCoinEffectNode.getComponent( cc.Label ).string = `+${lakeAddCoins}`;
            cc.tween( addCoinEffectNode )
                .by( 1.5,{y:200,opacity:-150} )
                .call(()=>{
                    addCoinEffectNode.removeFromParent();
                    addCoinEffectNode.destroy();
                })
                .start();
        });
    }

    /**
     * 钞票动画
     * @param start vec2 | cc.Node  如果是坐标需要世界坐标
     * @param parentNode
     */
    ChaoPiaoAni(start: cc.Vec2|cc.Node,end:cc.Vec2|cc.Node,parentNode:cc.Node = null)//chaopiao动画
    {
        let startPos:cc.Vec2 = null;
        if (!parentNode) {
            parentNode = O1HD.Canvas()
        }
        if(start instanceof cc.Node){
            startPos = parentNode.convertToNodeSpaceAR(start.convertToWorldSpaceAR(cc.v2()));
        }else{
            startPos = parentNode.convertToNodeSpaceAR(start.clone());
        }
        let lastpos = null;
        if(end instanceof cc.Node){
            lastpos = parentNode.convertToNodeSpaceAR(end.convertToNodeSpaceAR(cc.v2()));
        }else{
            lastpos = parentNode.convertToNodeSpaceAR(end);
        }
        for (let i = 0; i < Math.round(Math.random() * 10) + 10; i++) {
            let cp:cc.Node = cc.instantiate(this.chaoPiaoPrefab)
            cp.zIndex = Number.MAX_VALUE;
            cp.setParent(parentNode);
            cp.x = startPos.x
            cp.y = startPos.y
            let f = 1
            if (Math.random() > 0.5) {
                f = 1
            } else {
                f = -1
            }
            let time = Math.random() * 1 + 1
            let c1 = cc.v2(cp.x + Math.random() * 50 * f, cp.y + Math.random() * 20)
            let c2 = cc.v2(c1.x + Math.random() * 50 * f, c1.y + Math.random() * 20)
            cc.tween(cp).bezierTo(time, c1, c2, cc.v2(lastpos.x, lastpos.y)).call(() => {
                cp.destroy();
                cp.removeFromParent();
            }).start();
        }
    }

    private addDeskKey:string = "user-adddesk-key";

    //判断能不能给奖励
    checkCanAddDestokAward(){
        let key =  O1HD.getServices().localStorageSrv.getStorage(this.addDeskKey);
        return key != "1";
    }

    setCanAddDestokAward(){
        O1HD.getServices().localStorageSrv.setStorage(this.addDeskKey,"1");
    }

}
